namespace Gamification.Gamification {
    export interface ProdottiRisorseForm {
        UserId: Serenity.IntegerEditor;
        TenantId: Serenity.IntegerEditor;
        IdProdotto: Serenity.LookupEditor;
        IdRisorsa: Serenity.LookupEditor;
    }

    export class ProdottiRisorseForm extends Serenity.PrefixedContext {
        static formKey = 'Gamification.ProdottiRisorse';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ProdottiRisorseForm.init)  {
                ProdottiRisorseForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.LookupEditor;

                Q.initFormType(ProdottiRisorseForm, [
                    'UserId', w0,
                    'TenantId', w0,
                    'IdProdotto', w1,
                    'IdRisorsa', w1
                ]);
            }
        }
    }
}
